import { render, staticRenderFns } from "./VisitorRealNameRigistration.vue?vue&type=template&id=6ad523c4&scoped=true"
import script from "./VisitorRealNameRigistration.vue?vue&type=script&lang=js"
export * from "./VisitorRealNameRigistration.vue?vue&type=script&lang=js"
import style0 from "./VisitorRealNameRigistration.vue?vue&type=style&index=0&id=6ad523c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad523c4",
  null
  
)

export default component.exports